module.exports = "/img/_/_/_/assets/images/creeper/book/legendary//empty.jpg?96d4b85316a24d07b4592c7a0fdf838b";